import React, { Component } from "react";

import PropTypes from "prop-types";

import {
  Button,
  DropdownItem,
  DropdownToggle,
  ButtonDropdown,
  DropdownMenu,
  Spinner,
} from "reactstrap";

import { withTranslation } from "react-i18next";
import { AgGridReact } from "ag-grid-react";
import { tableLanguage } from "common/Constants/PageTable/tableLang";
import BooleanCellRender from "./CellRenderers/BooleanCellRender";
import BooleanStringCellRender from "./CellRenderers/BooleanStringCellRender";
import DateTimeCellRender from "./CellRenderers/DateTimeCellRender";
import DateCellRender from "./CellRenderers/DateCellRender";
import CurrencyCellRender from "./CellRenderers/CurrencyCellRender";
import IncludeCellRenderer from "./CellRenderers/IncludeCellRenderer";
import ActivePassiveCellRender from "./CellRenderers/ActivePassiveCellRender";
import FileStatusCellRenderer from "./CellRenderers/FileStatusCellRenderer";
import AlertStatusCellRender from "./CellRenderers/AlertStatusCellRender";
import MmyyDateCellRender from "./CellRenderers/MmyyDateCellRender";
import BooleanCheckCellRender from "./CellRenderers/BooleanCheckCellRender";
import { Breadcrumbs } from "../../CombinedComponents";

import * as moment from "moment";

import "ag-grid-enterprise";
import "ag-grid-enterprise/styles//ag-grid.css";
import "ag-grid-enterprise/styles//ag-theme-alpine.css";

import { uniqueIdentifier } from "./CellRenderers/CellFunctions";
import  ActionOperations  from "./CellRenderers/ActionOperations";
import { connect } from "react-redux";

class RavenAgTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      statusBar: {
        statusPanels: [{ statusPanel: "agAggregationComponent" }],
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading or try search panel instead.</span>',
      overlayNoRowsTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading or try search panel instead.</span>',
      icons: {
        search: '<i class="fas fa-search fa-flip-both"/>',
      },
      tooltipShowDelay: 0,
      tooltipHideDelay: 2000,
      sideBar: {
        toolPanels: [
          this.props.SearchContent
            ? {
                id: "search",
                labelDefault: this.props.t("search"),
                labelKey: "search",
                iconKey: "search",
                toolPanel: this.props.SearchContent,
              }
            : "",
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
            toolPanelParams: {
              suppressRowGroups: false,
              suppressValues: true,
              suppressPivots: true,
              suppressPivotMode: true,
            },
          },
        ],
      },
      baseColumns : [
        {
          field: this.props.t(""),
          pinned: "left",
          suppressColumnFilter: false,
          cellRenderer: ActionOperations,
          cellRendererParams: {
            translate: this.props.t,
            edit: this.props.onEditClick,
            delete: this.props.onDeleteClick,
            detail: this.props.onDetailClick,
            memo:this.props.onMemoClick,
            dynamicFunction: this.props.onDynamicFunction,
            dynamicFunction2: this.props.onDynamicFunction2,
            dynamicFunctionIcon: this.props.dynamicFunctionIcon,
            dynamicFunctionIcon2: this.props.dynamicFunctionIcon2,
            dynamicFunctionName: this.props.dynamicFunctionName,
            dynamicFunctionName2: this.props.dynamicFunctionName2,
            dynamicFunctionStatus: this.props.dynamicFunctionStatus,
            dynamicFunctionStatus2: this.props.dynamicFunctionStatus2
          },
          singleClickEdit: true,
          suppressToolPanel: !this.props.actionItems,
          suppressColumnsToolPanel: !this.props.actionItems,
          maxWidth: 40,
          sortable: false,
          filters: false,
          hide: !this.props.actionItems,
        },
  
        ...this.props.recordcolumns,
      ],
      updatedColumns: [],
      newList: [],
    };
  }


  componentDidUpdate() {
    if (
      this.state.updatedColumns.some(column => column.colDef.valueFormatter)
    ) {
      this.gridApi.aggFuncService && this.gridApi.refreshCells();
    }
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setState({ updatedColumns: this.gridColumnApi.getColumns() });
    const columnDefs = this.gridColumnApi.getColumns().map(column => {
      const colDef = column.getColDef();

      return {
        ...colDef,
        minWidth: this.setMinWidthByHeaderName(
          column.colDef.headerName,
          column.colDef.minWidth
        ),
        flex: 1,
      };
    });

    this.gridApi.setColumnDefs(columnDefs);
    this.gridColumnApi.autoSizeColumns(
      columnDefs.map(column => column.colId),
      false
    );
  };

  setMinWidthByHeaderName = (headerName, minWidth) => {
    if (headerName) {
      if (minWidth > 0) {
        return minWidth;
      }
      if (headerName < 14) return 150;
      else if (headerName.length < 23) return 200;
      else return 250;
    }
    return 150;
  };

  onBtnExportDataAsExcel = () => {
    let excelParams = {
      fileName:
        this.props.breadCrumbItem + moment().format("DD-MM-YYYY hh-mm-ss"),
    };
    this.gridApi.exportDataAsExcel(excelParams);
  };

  onBtnExportDataAsCsv = () => {
    let csvParams = {
      fileName:
        this.props.breadCrumbItem + moment().format("DD-MM-YYYY hh-mm-ss"),
    };
    this.gridApi.exportDataAsCsv(csvParams);
  };

  onCellEditingStopped = e => {
    e.data = this.props.cellEditValidation(e.data);
    this.setState({ newList: [...this.state.newList, e.data] });
    let newList = [];
    newList.push(e.data);
    this.props.tableRecordProps(newList);
  };

  onSelectionChanged = () => {
    let selectedRows = this.gridApi.getSelectedRows();
    this.setState({ selectedDataList: selectedRows });
  };

  
  renderMainButton() {
    if (!this.props.onAddClick) return null;
    return (
      <Button
        type="button"
        color="link"
        className="btn btn-outline"
        onClick={this.props.onAddClick}
        style={{ color: "#000000" }}
      >
        <i
          className={this.props.mainButtonIcon || "bx bxs-file-plus font-size-15"}
          style={{ color: "#000000" }}
        ></i>{" "}
        {this.props.t(this.props.mainButton || "addNew")}
      </Button>
    );
  }
  
  renderSecondButton() {
    if (!this.props.onSecondButtonClick) return null;
    return (
      <Button
        type="button"
        color="link"
        className="btn btn-outline"
        onClick={this.props.onSecondButtonClick}
        style={{ color: "#000000" }}
      >
        <i
          className={this.props.secondButtonIcon || "bx bxs-file-plus font-size-15"}
          style={{ color: "#000000" }}
        ></i>{" "}
        {this.props.t(this.props.secondButton || "secondButton")}
      </Button>
    );
  }
  
  renderExportDropdown() {
    if (!this.props.exportOption) return null;
    return (
      <ButtonDropdown
        isOpen={this.state.exportDataDrp}
        toggle={() => this.setState({ exportDataDrp: !this.state.exportDataDrp })}
      >
        <DropdownToggle caret color="link" className="btn btn-outline" style={{ color: "#000000" }}>
          <i className="bx bx-export font-size-15" style={{ color: "#000000" }}></i>
          {this.props.t("export")}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => this.onBtnExportDataAsExcel()}>
            {this.props.t("exportExcel")}
          </DropdownItem>
          <DropdownItem onClick={() => this.onBtnExportDataAsCsv()}>
            {this.props.t("exportCsv")}
          </DropdownItem>
        </DropdownMenu>
      </ButtonDropdown>
    );
  }
  
  renderOperationsDropdown() {
    const items = this.props.DropdownItems;
    if (!items) return null;
  
    return (
      <ButtonDropdown
        isOpen={this.state.operationsDrp}
        toggle={() => this.setState({ operationsDrp: !this.state.operationsDrp })}
      >
        <DropdownToggle caret color="link" className="btn btn-outline">
          <i className="bx bx-dots-vertical-rounded font-size-16" />
        </DropdownToggle>
        <DropdownMenu>
          {items.map(item => (
            <DropdownItem
              key={uniqueIdentifier()}
              onClick={() => item.func(this.state)}
            >
              {this.props.t(item.operationName)}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </ButtonDropdown>
    );
  }
  
  renderGrid() {
    const { recordList, loading } = this.props;
    const excelStyles = [{ id: "stringType", dataType: "String" }];
  
    if (loading) {
      return <Spinner className="position-absolute top-50 start-50 primary" />;
    }
  
    return (
      <AgGridReact
        defaultColDef={{
          sortable: true,
          filter: true,
          autosize: true,
          resizable: true,
          menuTabs: ["filterMenuTab", "generalMenuTab"],
          enableRowGroup: true,
          filterParams: {
            excelMode: 'windows',
            buttons: ["apply", "reset"],
          },
        }}
        components={{
          dateCellRender: DateCellRender,
          dateTimeCellRender: DateTimeCellRender,
          activePassiveCellRender: ActivePassiveCellRender,
          fileStatusCellRenderer: FileStatusCellRenderer,
          alertStatusCellRender: AlertStatusCellRender,
          booleanCellRender: BooleanCellRender,
          booleanCheckCellRender: BooleanCheckCellRender,
          booleanStringCellRender: BooleanStringCellRender,
          includeCellRenderer: IncludeCellRenderer,
          mmyyDateCellRender: MmyyDateCellRender,
          currencyCellRender: CurrencyCellRender,
        }}
        sideBar={this.state.sideBar}
        icons={this.state.icons}
        statusBar={this.state.statusBar}
        tooltipShowDelay={this.state.tooltipShowDelay}
        tooltipHideDelay={this.state.tooltipHideDelay}
        onRowClicked={this.props.rowClickFunc ? e => this.props.rowClickFunc(e.data) : undefined}
        rowData={recordList}
        columnDefs={this.state.baseColumns}
        excelStyles={excelStyles}
        enableRangeSelection={true}
        suppressMenuHide={true}
        enableRangeHandle={true}
        overlayLoadingTemplate={this.state.overlayLoadingTemplate}
        overlayNoRowsTemplate={this.state.overlayNoRowsTemplate}
        animateRows={true}
        localeText={tableLanguage}
        onGridReady={this.onGridReady}
        pagination={true}
        paginationAutoPageSize={this.props.paginationPageSize === undefined}
        paginationPageSize={this.props.paginationPageSize ?? 10}
        onCellEditingStopped={this.onCellEditingStopped}
        onSelectionChanged={this.onSelectionChanged}
      />
    );
  }
  
  render() {
    return (
      <React.Fragment>
        <div className="d-flex align-items-center">
          <div className="mb-0 card flex-grow-1">
            <Breadcrumbs
              title={this.props.breadCrumbTitle || ""}
              breadcrumbItem={this.props.breadCrumbItem || ""}
            />
          </div>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <div className="btn-group-horizantal" role="group">
              {this.renderMainButton()}
              {this.renderSecondButton()}
              {this.renderExportDropdown()}
              {this.renderOperationsDropdown()}
            </div>
          </div>
        </div>
        <div
          className="ag-theme-alpine"
          style={{
            height: this.props.gridHeight || "550px",
          }}
        >
          {this.renderGrid()}
        </div>
      </React.Fragment>
    );
  }
  
}

RavenAgTable.propTypes = {
  loading :PropTypes.bool,
  rowClickFunc: PropTypes.func,
  mainButton: PropTypes.any,
  mainButtonIcon: PropTypes.any,
  secondButton: PropTypes.any,
  secondButtonIcon: PropTypes.any,
  gridHeight: PropTypes.string,
  onAddClick: PropTypes.func,
  onSecondButtonClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onDynamicFunction: PropTypes.func,
  onDynamicFunction2: PropTypes.func,
  dynamicFunctionName: PropTypes.any,
  dynamicFunctionName2: PropTypes.any,
  dynamicFunctionIcon: PropTypes.any,
  dynamicFunctionIcon2: PropTypes.any,
  dynamicFunctionStatus: PropTypes.any,
  dynamicFunctionStatus2: PropTypes.any,
  actionItems: PropTypes.bool,
  SearchContent: PropTypes.any,
  DropdownItems: PropTypes.any,
  onDetailClick: PropTypes.func,
  onMemoClick : PropTypes.func,
  onDeleteClick: PropTypes.func,
  onCloseClick: PropTypes.func,
  onSearchClick: PropTypes.func,
  handleAddRecordClick: PropTypes.func,
  exportOption: PropTypes.bool,
  showSecondButton: PropTypes.bool,
  recordcolumns: PropTypes.any,
  recordList: PropTypes.any,
  record: PropTypes.any,
  sizePerPage: PropTypes.any,
  show: PropTypes.any,
  breadCrumbTitle: PropTypes.string,
  breadCrumbItem: PropTypes.string,
  t: PropTypes.any,
  cellEditValidation: PropTypes.func,
  tableRecordProps: PropTypes.func,
  paginationPageSize: PropTypes.any,
};


export default connect()(withTranslation()(RavenAgTable));
